import { BaseDto } from '.././base.dto';

export class BillingPlanDto extends BaseDto {
  name?: string;
  active?: boolean;
  description?: string;
}
